module.exports = __webpack_public_path__ + "img/chessportals.c437c26e.png";